const SmallWhiteEnvelopIcon = () =>{
    return(
        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.62469 5.21913C5.19343 4.87412 4.56414 4.94404 4.21913 5.37531C3.87412 5.80657 3.94404 6.43586 4.37531 6.78087L8.75061 10.2811C9.48105 10.8655 10.519 10.8655 11.2494 10.2811L15.6247 6.78087C16.056 6.43586 16.1259 5.80657 15.7809 5.37531C15.4359 4.94404 14.8066 4.87412 14.3753 5.21913L10 8.71938L5.62469 5.21913Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C2.23858 0 0 2.23858 0 5V13C0 15.7614 2.23858 18 5 18H15C17.7614 18 20 15.7614 20 13V5C20 2.23858 17.7614 0 15 0H5ZM2 5C2 3.34315 3.34315 2 5 2H15C16.6569 2 18 3.34315 18 5V13C18 14.6569 16.6569 16 15 16H5C3.34315 16 2 14.6569 2 13V5Z" fill="white"/>
        </svg>
    )
}

export default SmallWhiteEnvelopIcon